import { Form } from '@remix-run/react';
import React, { FC, useEffect, useState } from 'react';

import { CloseModalConfirmationDialog } from './CloseModalConfirmationDialog/closeModalConfirmationDialog';

type Props = {
    buttons?: React.ReactElement[];
    closeText?: string;
    content: React.ReactElement[];
    heading: string;
    id: string; // unique ID
    large?: boolean;
    onClickOutside?: () => any;
    onClose?: () => any;
    onSubmit?: (formEvent: React.FormEvent<HTMLFormElement>) => any;
    open: boolean;
    preventRefresh?: boolean;
};

export const Modal: FC<Props> = ({
    buttons,
    closeText,
    content,
    heading,
    id,
    large,
    onClickOutside,
    onClose,
    onSubmit,
    open,
    preventRefresh,
}: Props): React.ReactElement => {
    const [isAreYouSureDialogOpen, setIsAreYouSureDialogOpen] =
        useState<boolean>(false);
    const [hasBeenChanged, setHasBeenChanged] = useState<boolean>(false);

    useEffect(() => {
        if (preventRefresh) {
            const handleBeforeUnload = (event: BeforeUnloadEvent) => {
                if (open) {
                    // Perform actions before the component unloads
                    event.preventDefault();
                    event.returnValue = '';
                    return '';
                }
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [open, preventRefresh]);

    return (
        <Form
            autoComplete="off"
            onChange={() => {
                setHasBeenChanged(true);
            }}
            onSubmit={(e) => {
                e.preventDefault();
                if (onSubmit) onSubmit(e);
                if (onClose) onClose();
            }}
        >
            {isAreYouSureDialogOpen && (
                <CloseModalConfirmationDialog
                    onCloseClicked={() => {
                        setIsAreYouSureDialogOpen(false);
                        if (onClose) onClose();
                    }}
                    onDismissClicked={() => setIsAreYouSureDialogOpen(false)}
                    open={isAreYouSureDialogOpen}
                />
            )}
            {!large && (
                <dialog className="modal" id={id} open={open}>
                    <div className="modal-box">
                        <h3 className="text-lg font-bold">{heading}</h3>
                        <div className="py-4">{content}</div>
                        <div className="modal-action">
                            <button
                                className="btn"
                                key="close-button"
                                onClick={() => {
                                    if (onClose) onClose();
                                }}
                            >
                                {closeText ? closeText : 'Close'}
                            </button>
                            ,{buttons}
                        </div>
                    </div>
                    <label
                        aria-hidden
                        className="modal-backdrop"
                        htmlFor={id}
                        onClick={() => {
                            if (onClickOutside) onClickOutside();
                            if (hasBeenChanged) {
                                console.log(
                                    'Has been changed is set and state is being set'
                                );
                                setIsAreYouSureDialogOpen(true);
                            } else {
                                document.documentElement.style.scrollBehavior =
                                    '';

                                console.log('Has not been changed');

                                if (onClose) onClose();
                            }
                        }}
                    >
                        Close
                    </label>
                </dialog>
            )}
            {large && (
                <dialog className="modal" id={id} open={open}>
                    <div className="modal-box w-11/12 max-w-5xl">
                        <h3 className="text-lg font-bold">{heading}</h3>
                        <div className="py-4">{content}</div>
                        <div className="modal-action">
                            <button
                                className="btn"
                                key="close-button"
                                type="submit"
                            >
                                {closeText ? closeText : 'Close'}
                            </button>
                            {buttons}
                        </div>
                    </div>
                    <label
                        aria-hidden
                        className="modal-backdrop"
                        htmlFor={id}
                        onClick={() => {
                            if (onClickOutside) onClickOutside();
                            if (hasBeenChanged) {
                                console.log(
                                    'Has been changed is set and state is being set'
                                );
                                setIsAreYouSureDialogOpen(true);
                            } else {
                                document.documentElement.style.scrollBehavior =
                                    '';

                                if (onClose) onClose();
                            }
                        }}
                    >
                        Close
                    </label>
                </dialog>
            )}
        </Form>
    );
};
